module.exports = __webpack_public_path__ + "img/job.c807d137.png";